import { Component, OnInit, ViewChild } from '@angular/core';
import {ICellRendererParams} from "ag-grid-community";
import {AgRendererComponent} from "ag-grid-angular";
import { MatLegacyMenuTrigger as MatMenuTrigger } from '@angular/material/legacy-menu';
import { isEmpty } from 'lodash-es';
import { IntegrationRef } from '../../../app.model';

@Component({
  selector: 'app-destination-render',
  templateUrl: './destination-render.component.html',
  styleUrls: ['./destination-render.component.scss']
})
export class DestinationRenderComponent implements AgRendererComponent {
  
  @ViewChild(MatMenuTrigger) destinationActionMenuBtn: MatMenuTrigger;
  
  status:any;
  warehouses: any
  destlogoUrl: string;
  focusIndex: number;
  dataLength;
  destAddIcon: boolean;
  public params: ICellRendererParams;

  agInit(params: ICellRendererParams): void {//console.log("DestinationRenderComponent", params)
      this.params = params; //console.log(this.params)
      this.warehouses = this.params['warehouses']//.filter(w => w.status === 'ENABLED')
      this.dataLength = this.params['dataLength'];
      // this.warehouses.forEach(element => {
      //   element['dropdown_status'] = false
      // });
      this.destlogoUrl = this.params.value;
      if (isEmpty(this.destlogoUrl)) {
        this.destAddIcon = true;
      } else {
        this.destAddIcon = false;
      }
     // console.log(this.destlogoUrl,"this.destlogoUrl")
  }

  public invokeParentMethod() {
      this.params.context.componentParent.methodFromParent(`Row: ${this.params.node.rowIndex}, Col: ${this.params.colDef.headerName}`)
  }

  refresh(): boolean {
      return false;
  }

  setWarehouse() {
    this.status = !this.status
    this.params.context.componentParent
    .setWarehouse(this.warehouses[this.focusIndex].warehouseId, this.params.data.sourceId, this.params.data.userId);

  }

  routeToDest() {

    this.status = !this.status
    this.params.context.componentParent
    .routeToDest( this.params.data.sourceId, this.params.data.userId);

  }

  routeToDetails() {//console.log("rou")
  let integration: IntegrationRef = {
    "integrationName": this.params.data.integrationName,
    "sourceId": this.params.data.sourceId,
    "status": this.params.data.status,
    "destinationName": this.params.data.destinationName
  }
  this.params.context.componentParent?.routeToDetails?.(integration);
}

closeDestinationActionMenu() {
  this.destinationActionMenuBtn.closeMenu()
}
 
}

